// Interfaces
import clsx from "clsx";
import { ITabLoader } from "./interfaces";

// MUI
import { Skeleton, Stack } from "@mui/material";

const SwitchLabelLoader = (props: { classes?: string; width?: number; mt?: number | string }) => {
	const { classes = "", width = 140, mt = 0 } = props;
	return (
		<Stack
			className={clsx({
				"w-[100%]": true,
				[classes]: Boolean(classes),
			})}
			alignItems={"flex-end"}
			mt={mt}
		>
			<Stack direction={"row"} alignItems={"center"} spacing={1} height={"30px"}>
				<Skeleton variant="text" width={width} height={20} />
				<Skeleton variant="rectangular" className="rounded-[15px]" width={45} height={22} />
			</Stack>
		</Stack>
	);
};

export default function TabLoader(props: Readonly<ITabLoader>) {
	const { tabs = 2, switch: hasSwitch, bottomSwitch } = props;
	return (
		<>
			<Stack direction={"row"} justifyContent={"space-between"} alignItems={"flex-end"} className="px-[32px] py-0">
				<Stack direction={"row"} justifyContent={"flex-start"}>
					{Array.from(Array(tabs)).map((_, key) => {
						const keyItem = `tab_loader_${key}`;
						return <Skeleton key={keyItem} variant="rectangular" className="rounded-t-[6px]" width={127} height={30} />;
					})}
				</Stack>
				{hasSwitch && <SwitchLabelLoader />}
			</Stack>
			<Skeleton variant="rectangular" width={"100%"} height={1} sx={{ borderRadius: "6px" }} />
			{bottomSwitch && <SwitchLabelLoader mt={"5px"} width={170} classes="px-[32px] py-0" />}
		</>
	);
}
